import {formatDistanceToNow} from "date-fns";

import {dateStringWithTimezone, timeStringWithTimezone} from "@/components/datetime/utils.ts";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {AccountUser} from "@/lib/types/accounts.ts";
import {MaintenanceSchedule} from "@/lib/types/maintenance.ts";
import {getNextOccurrence} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/MaintenanceSchedulesTable.utils.ts";

export const TimeUntil = ({schedule, user}: {schedule: MaintenanceSchedule; user: AccountUser}) => {
  const nextOccurrence = getNextOccurrence(schedule);

  if (!nextOccurrence) return <span className="pulse-color-gray-500">Not Scheduled</span>;
  if (!schedule.is_active) return <span className="pulse-color-gray-500">Schedule Paused</span>;
  return (
    <Tooltip
      tooltipContent={`${dateStringWithTimezone(new Date(nextOccurrence.starts_at), user.account.timezone, user.current_date_format)} ${timeStringWithTimezone(new Date(nextOccurrence.starts_at), user.account.timezone, user.current_time_format)}`}
      delayMs={500}
    >
      <span className="d-flex flex-column">
        <div className={"pulseTextBodySmall"}>
          {formatDistanceToNow(new Date(nextOccurrence.starts_at), {addSuffix: true})}
        </div>
        <div className={"pulseTextBodyTiny pulse-color-gray-700"}>
          {timeStringWithTimezone(new Date(nextOccurrence.starts_at), user.account.timezone, user.current_time_format)}
        </div>
      </span>
    </Tooltip>
  );
};
